import { render, staticRenderFns } from "./DepartmentAboutModal.vue?vue&type=template&id=ebda36a6&scoped=true"
import script from "./DepartmentAboutModal.vue?vue&type=script&lang=js"
export * from "./DepartmentAboutModal.vue?vue&type=script&lang=js"
import style0 from "./DepartmentAboutModal.vue?vue&type=style&index=0&id=ebda36a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebda36a6",
  null
  
)

export default component.exports